import PropTypes from 'prop-types';

export const TableRowDefaultProps = {
  isHeader: false,
  tabIndex: 0,
  onSelect: () => null,
};

export const TableRowPropTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      type: PropTypes.string,
    }),
  ).isRequired,
  tabIndex: PropTypes.number,
  isHeader: PropTypes.bool,
  onSelect: PropTypes.func,
};
